var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoWishlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 223,
    height: 223,
    viewBox: "0 0 223 223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.001 0H223v223H.001z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.366
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECED",
    d: "M223.001 111.5c0 61.576-49.924 111.5-111.5 111.5C49.92 223 .001 173.077.001 111.5.001 49.92 49.92 0 111.501 0c61.576 0 111.5 49.92 111.5 111.5",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M72.29 68h91.386L175 154H64z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#020303",
    strokeWidth: 6,
    d: "M103.045 82.269L103 60.339c-.023-10.657 8.679-19.316 19.435-19.339 10.756-.022 19.497 8.598 19.514 19.254L142 83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M97 86.014A5.992 5.992 0 0 0 103.014 92 6 6 0 1 0 97 86.014M135 86.014A5.996 5.996 0 0 0 141.014 92 6 6 0 1 0 135 86.014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M55.502 142.28c-30.883-17.568-30.838-36.126-30.417-40.188.205-11.614 9.579-21.013 21.093-21.041 4.484 0 8.78 1.438 12.328 4.011A20.917 20.917 0 0 1 70.818 81c11.675 0 21.16 9.59 21.182 21.373 0 .635-.055 1.23-.139 1.826-.094 6.101-3.226 22.502-30.333 38.07L58.518 144l-3.016-1.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M85 104.06c-.017-7.784-6.41-14.077-14.285-14.06a14.266 14.266 0 0 0-11.692 6.104 14.284 14.284 0 0 0-11.726-6.06c-7.869.017-14.24 6.342-14.223 14.126h-.006S30.368 120.118 59 136c23.569-13.203 25.799-26.361 25.86-30.56.045-.458.14-.906.14-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#020303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M74.148 80.163L75.598 65h91.38L178 155H67l1.17-12.199"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWishlist);
export default __webpack_public_path__ + "static/media/no-wishlist.8af71b070feb39b85a05dbceddf620c6.svg";
export { ForwardRef as ReactComponent };